@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/form';

:host {
  // These can be overwritten, but are automatically set from context components

  // --padding-top: inherit;
  // --padding-bottom: inherit;
  // --padding-start: inherit;
  // --padding-end: inherit;
  // --margin: inherit;

  // --secondary-padding-top: inherit;
  // --secondary-padding-bottom: inherit;
  // --secondary-padding-start: inherit;
  // --secondary-padding-end: inherit;

  // --border-bottom: inherit;
  // --icon-size: inherit;

  // --color: inherit;
  // --color-hover: inherit;
  // --color-focus: inherit;
  // --color-selected: inherit;
  // --color-open: inherit;

  // --bg-color: inherit;
  // --bg-color-hover: inherit;
  // --bg-color-selected: inherit;
  // --bg-color-open: inherit;
  // --bg-color-focus: inherit;

  // --secondary-bg-color: inherit;
  // --secondary-color: inherit;

  opacity: inherit;
  display: block;
  color: var(--color) !important;
  margin: var(--margin);
  outline: none !important;

  .nav-item,
  .link {
    outline: none !important;
  }

  ::slotted(*),
  * {
    box-sizing: border-box;
  }

  ::slotted(button),
  button {
    background: none;
    border: none;
    margin: 0;
  }

  ::slotted(button),
  ::slotted(a),
  ::slotted(a:visited),
  button,
  a,
  a:visited {
    @include text-inherit();

    padding-inline: var(--padding-start) var(--padding-end);
    padding-block: var(--padding-top) var(--padding-bottom);
    display: var(--display, block);
    white-space: nowrap;
    color: var(--color) !important;
    background-color: var(--bg-color);
    line-height: inherit;
    outline: none !important;
  }

  ::slotted(nano-icon[slot='icon-start']) {
    padding-inline-end: var(--padding-end);
  }

  ::slotted(nano-icon[slot='icon-end']) {
    padding-inline-start: var(--padding-start);
  }

  .link {
    ::slotted(nano-icon[slot='icon-start']) {
      padding-inline-start: var(--padding-start);
      padding-inline-end: 0;
    }

    ::slotted(nano-icon[slot='icon-end']) {
      padding-inline-end: var(--padding-end);
      padding-inline-start: 0;
    }
  }

  .link,
  button,
  a {
    border-block-end: var(--border-bottom);
    display: flex;
    align-items: center;
  }

  .secondary-menu {
    display: none;
  }

  ::slotted(a:hover),
  ::slotted(button:hover),
  .link:hover,
  button:hover,
  a:hover {
    text-decoration: inherit !important;
  }

  button:focus-visible,
  a:focus-visible {
    color: var(--color-focus, var(--color-hover, var(--color))) !important;
    background-color:
      var(
        --bg-color-focus,
        var(--bg-color-hover, var(--bg-color))
      );
    box-shadow: #{$control-focus-style};
  }

  ::slotted(a:focus-visible),
  ::slotted(button:focus-visible) {
    color: var(--color-focus, var(--color-hover, var(--color))) !important;
    background-color:
      var(
        --bg-color-focus,
        var(--bg-color-hover, var(--bg-color))
      );
    box-shadow: #{$control-focus-style};
  }
}

.nav-item {
  &.selected {
    .link,
    button,
    a {
      color: var(--color-selected, var(--color-open, var(--color))) !important;
      background-color:
        var(
          --bg-color-selected,
          var(--bg-color-open, var(--bg-color))
        );
    }
  }

  &.secondary-open {
    button,
    a {
      color: var(--color-open, var(--color-selected, var(--color))) !important;
      background-color:
        var(
          --bg-color-open,
          var(--secondary-bg-color, var(--bg-color-selected, var(--bg-color)))
        );
    }
  }

  &.disabled {
    opacity: 0.6;

    button,
    a {
      color: var(--color-disabled, var(--color)) !important;
    }
  }

  &:not(.nano-menu) {
    ::slotted(a:hover),
    ::slotted(button:hover),
    .link:hover,
    button:hover,
    a:hover {
      color: var(--color-hover, var(--color-hover, var(--color))) !important;
      background-color:
        var(
          --bg-color-hover,
          var(--bg-color-focus, var(--bg-color))
        );
    }
  }
}

:host(.has-focus) {
  .link {
    color: var(--color-focus, var(--color-hover, var(--color))) !important;
    background-color:
      var(
        --bg-color-focus,
        var(--bg-color-hover, var(--bg-color))
      );
    outline: var(--focus-outline, 5px auto -webkit-focus-ring-color);
  }
}

:host(.nano-global-nav-menu),
:host(.nano-menu) {
  a,
  a:visited,
  button,
  .link {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    color: 'currentColor';
    text-decoration: inherit;
    white-space: normal;
    cursor: pointer;
    line-height: 1.2;
    width: 100%;
  }

  .text {
    padding-inline-start: 0;
    padding-inline-end: var(--padding-end);
    flex: 1;
  }

  ::slotted(a),
  ::slotted(button) {
    flex: 1;
  }

  .secondary-menu {
    display: none;
    position: absolute;
    color: var(--secondary-color, 'currentColor');
    min-height: 100%;
    inset-block-start: 0;
    inset-inline-start: 0;
    width: 100%;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.2s ease, transform 0.3s ease;
    background-color: var(--secondary-bg-color, white);
    transform: translateX(100%);

    &:focus {
      outline: none;
    }

    &.open {
      opacity: 1;
      transform: translateX(0);
      transition: opacity 0.3s ease, transform 0.2s ease;
    }
  }
}

:host(.nano-global-nav-menu) {
  ::slotted(nano-icon[slot='icon-start']) {
    padding-inline: 0 var(--padding-end);
    padding-block: 0;
  }

  ::slotted(nano-icon[slot='icon-end']) {
    padding-inline: 0 var(--padding-end);
    padding-block: 0;
    font-size: 10px;
    flex: 0 0 10px;
    pointer-events: none;
  }

  button,
  a {
    ::slotted(nano-icon[slot='icon-end']) {
      padding: 0;
    }
  }
}

:host(.nano-global-nav-menu[dir='rtl']),
:host(.nano-menu[dir='rtl']) {
  .secondary-menu {
    transform: translateX(-100%);

    &.open {
      transform: translateX(0);
    }
  }
}

:host(.nano-menu) {
  ::slotted(a:focus),
  ::slotted(button:focus) {
    box-shadow: none;
  }

  .secondary-menu-content {
    padding-inline: var(--secondary-padding-start) var(--secondary-padding-end);
    padding-block: var(--secondary-padding-top) var(--secondary-padding-bottom);
  }
}

:host(.nano-global-nav-bar) {
  .link,
  a,
  button {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .text {
    flex: 1 0 auto;
  }

  ::slotted(nano-icon[slot='icon-end']) {
    margin-inline: var(--padding-end) 0;
    margin-block: 0;
  }

  ::slotted(nano-icon[slot='icon-start']) {
    margin-inline: 0 var(--padding-start);
    margin-block: 0;
  }

  ::slotted(a),
  button {
    position: relative;

    &::before {
      content: '';
      background-color: rgb(12, 90, 113);
      height: 9px;
      inset-inline: 0 5px;
      inset-block-end: -22px;
      position: absolute;
      transform: translateZ(0) scaleX(0);
      transform-origin: 0;
      transition: 0.2s ease transform;
    }
  }

  .selected button::before,
  .secondary-open button::before {
    transform: translateZ(0) scaleX(1);
  }
}

:host(.nano-global-nav-bar.selected) {
  ::slotted(a) {
    &::before {
      transform: translateZ(0) scaleX(1);
    }
  }
}

:host(.nano-global-nav-bar.has-secondary) {
  .secondary-open button::before {
    opacity: 0.7;
  }

  .secondary-menu {
    display: none;
    transition: transform 0.3s ease;
    transform: translateY(-100%) translateZ(0);
    background-color: var(--secondary-bg-color, #196c82);
    color: var(--secondary-color);
    position: absolute;
    box-shadow: 0 1px 25px 0 rgba(0, 0, 0, 0.15);
    inset-inline: 0;
    z-index: -2;
    outline: none;

    &.open {
      transform: translateY(12px) translateZ(0);
    }
  }
}

:host(.nano-menu-drawer) {
  .link,
  a,
  button {
    padding-block-start: calc(var(--padding-top) / 2);
    padding-inline-end: 0;
    padding-block-end: calc(var(--padding-bottom) / 2);
    padding-inline-start: var(--padding-start);
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    color: currentColor;
    text-decoration: inherit;
    white-space: normal;
    border: none;
    cursor: pointer;
    line-height: 1.2;
    width: 100%;
  }

  .text {
    padding-inline-end: var(--padding-end);
    padding-inline-start: 0;
    text-align: start;
    flex: 0 1 auto;
    min-width: 130px;
    width: 130px;
  }

  ::slotted(nano-icon[slot='icon-start']) {
    padding-inline: 0 var(--padding-end);
    padding-block: 0;
    font-size: var(--icon-size);
    width: var(--icon-size);
    flex: 0 0 var(--icon-size);
  }

  ::slotted(nano-icon[slot='icon-end']) {
    padding: 0 var(--padding-end) 0 0;
    font-size: 10px;
    flex: 0 0 20px;
    min-width: 20px;
  }

  .secondary-menu {
    display: none;
    position: absolute;
    background-color: var(--secondary-bg-color);
    color: var(--secondary-color);
    height: 100vh;
    inset-inline: auto 0;
    inset-block: 0;
    transform: translateX(0);
    z-index: -1;
    transition: transform 0.3s ease, opacity 0.2s ease;
    overflow-y: auto;
    width: var(--secondary-width, 400px);
    max-width: 62vw;
    opacity: 1;
    padding-inline: var(--secondary-padding-start, var(--padding-start)) var(--secondary-padding-end, var(--padding-end));
    padding-block: var(--secondary-padding-top, var(--padding-top)) var(--secondary-padding-bottom, var(--padding-bottom));

    &:focus {
      outline: none;
    }

    &.open {
      transform: translateX(100%);
    }
  }

  .notification {
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 6px;
      height: 6px;
      background-color: #ef4135;
      inset-inline-start: 10px;
      inset-block-start: 7px;
      border-radius: 50%;

      @media (min-width: 52em) {
        width: 7px;
        height: 7px;
        inset-inline-start: 8px;
        inset-block-start: 5px;
      }
    }
  }
}

:host(.nano-menu-drawer[dir='rtl']) {
  .secondary-menu {
    transform: translateX(0%);

    &.open {
      transform: translateX(-100%);
      opacity: 1;
    }
  }
}
